// extracted by mini-css-extract-plugin
export default {"inputWrapper":"dxsCBx","input":"mZk_gJ"};